<template>
  <div
    class="row card borderless-card"
    style="box-shadow: none; padding-left: 30px; padding-right: 30px"
  >
    <div class="col-12" style="padding: 0">
      <div
        class="row mb-3 mt-2"
        style="justify-content: space-between; margin: auto"
      >
        <div class="team-title d-flex">
          <i class="material-icons-outlined user-font mr-2 material-icon-font"
            >list_alt</i
          >
          <div style="margin-top: auto; margin-bottom: auto">Registrar</div>
        </div>
        <div>
          <button class="newTask" style="margin-right: 16px" @click="download">
            <i class="fa fa-download" aria-hidden="true"></i>Download CSV
          </button>
          <button
            class="newTask"
            @click="handleCreateRegister"
            v-if="showAddButton"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>Add Registrar
          </button>
        </div>
      </div>

      <div class="col-6 card">
        <div class="col-12">
          <div class="row value-card">
            <div class="col-4">
              <div class="gp-medium-dashboard pb-1">Total Proceeds</div>
              <div class="gp-medium-dashboard-value">
                ${{ formatNumberWithComma(totalIRRProfit) }}
              </div>
            </div>
            <div class="col-4">
              <div class="gp-medium-dashboard pb-1">Total Cost</div>
              <div class="gp-medium-dashboard-value">
                (${{ formatNumberWithComma(totalIRRCost) }})
              </div>
            </div>
            <div class="col-4">
              <div class="gp-medium-dashboard pb-1">IRR</div>
              <div class="gp-medium-dashboard-value">
                {{ irrValue }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="padding-left: 15px">
        <div class="form-group has-search">
          <span
            class="fa fa-search form-control-feedback"
            style="margin-top: 0"
          ></span>
          <input
            type="text"
            class="form-control upcoming-tasks-search"
            aria-controls="datatables"
            v-model="searchQuery"
            style="width: 203px"
            placeholder="Search Records"
          />
        </div>
        <div>
          <button
            class="newTask filterBtn ml-2"
            style="border: 0px; height: 100%"
            @click="showFilter = !showFilter"
          >
            <img src="static/img/filter.svg" class="mr-1" />
            Filters
          </button>
          <div v-if="showFilter" class="filterDiv">
            <div class="filterForm">
              <div class="row" style="margin-bottom: 20px">
                <div class="col-12">
                  <div style="font-size: 14px; margin-bottom: 10px">
                    Company
                  </div>
                  <multiselect
                    v-model="companiesList"
                    :options="portfolioAll"
                    :multiple="true"
                    track-by="_id"
                    label="name"
                    :custom-label="searchName"
                    placeholder="Select Company"
                  >
                    <template slot="option" slot-scope="props">
                      <div class="option__desc d-flex">
                        <img
                          class="optionCompanyImage"
                          v-if="
                            props.option.logo_url &&
                            props.option.logo_url.length > 0
                          "
                          :src="props.option.logo_url"
                        />
                        <div class="option__title">{{ props.option.name }}</div>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div style="font-size: 14px; margin-bottom: 10px">Round</div>
                  <el-select
                    class="todo-dropdown-el-select"
                    size="small"
                    required
                    placeholder="Select Round"
                    v-model="filterRound"
                  >
                    <el-option
                      v-for="(item, index) in roundArray"
                      :key="index"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div style="font-size: 14px; margin-bottom: 10px">
                    Investment Type
                  </div>
                  <el-select
                    class="todo-dropdown-el-select"
                    size="small"
                    required
                    placeholder="Select Investment type"
                    v-model="filterInvestmentType"
                  >
                    <el-option
                      v-for="(item, index) in investmentTypeArray"
                      :key="index"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div style="font-size: 14px; margin-bottom: 10px">
                    Transaction Type
                  </div>
                  <el-select
                    class="todo-dropdown-el-select"
                    size="small"
                    required
                    placeholder="Select Transaction type"
                    v-model="filterTransactionType"
                  >
                    <el-option
                      v-for="(item, index) in transactionTypeArray"
                      :key="index"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="filterFormBtns d-flex">
              <button
                class="newTask"
                style="border: 0px; cursor: pointer"
                @click="clearAll"
              >
                Clear all
              </button>
              <button
                class="newTask"
                style="border: 0px; cursor: pointer"
                @click="applyFilter"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
      <div id="theMainTableFixerInvestments">
        <div
          class="tabulator registrar-table"
          ref="table"
          style="width: 100%; height: 100%"
        ></div>
      </div>
      <el-dialog
        center
        title="Really Delete?"
        :closeOnClickModal="false"
        :closeOnPressEscape="false"
        width="750px"
        style="margin: 0 auto"
        :visible.sync="confirmMdlShow"
        class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
      >
        <div class="card-body">
          <div class="inputs row">
            <p style="width: 100%; text-align: center">
              Are you sure you want to delete this item? This can't be undone.
            </p>
          </div>
          <div class="actionbuttons">
            <button
              @click.prevent="
                confirmMdlShow = !confirmMdlShow;
                deleteItem = {};
                submitted = false;
              "
              class="todo-form-cancel-button btn-outline-secondary"
            >
              Cancel
            </button>
            <button
              class="btn btn-info btn-fill btn-wd"
              style="height: 35px"
              :disabled="submitted"
              @click="deleteMethod"
            >
              Yes
              <b-spinner v-if="submitted" small label="Spinning"></b-spinner>
            </button>
          </div>
        </div>
      </el-dialog>
      <DialogMyRegistrarForm
        v-model="dialogMyRegistrarData"
      ></DialogMyRegistrarForm>
      <DialogAddInvestmentForm
        v-model="dialogMyInvestmentData"
        :investmentData="rowInvestmentData"
        context="company-profile"
        :currentCompany="currentCompany"
        :investments="investmentData"
      ></DialogAddInvestmentForm>
    </div>
    <custom-menu></custom-menu>
  </div>
</template>
<script>
import _ from "lodash";
import Avatar from "vue-avatar";
import moment from "moment";
import Tabulator from "tabulator-tables";
import portfolio from "../../../store/modules/fake/portfolio";
import {
  vals,
  formatCurrency,
  formatNumber,
  formatNumberWithComma,
} from "../../../util";
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import { Select, Option, Dialog } from "element-ui";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import DialogMyRegistrarForm from "../Dialogs/DialogAddRegistrarForm";
import DialogAddInvestmentForm from "../Dialogs/DialogAddInvestmentForm";
import CustomMenu from "../Components/CustomMenu.vue";
import Multiselect from "vue-multiselect";
import config from "../../../../config/settings";
export default {
  components: {
    [Dialog.name]: Dialog,
    [Option.name]: Option,
    [Select.name]: Select,
    Avatar,
    VueBootstrapTypeahead,
    DialogMyRegistrarForm,
    DialogAddInvestmentForm,
    [CustomMenu.name]: CustomMenu,
    Multiselect,
  },
  watch: {
    transactionDetails: {
      handler: function (newData) {
        if (this.tabulator) {
          this.tabulator.updateData(newData.data);
        }
      },
    },
    searchQuery: _.debounce(function (newVal) {
      const self = this;
      if (!self.isFilterApplied || self.searchQuery.length == 0) {
        this.tabulator.clearFilter(true);
      }
      let appliedFilters = self.customFilterArray;
      self.searchFilter = [
        { field: "offering", type: "like", value: self.searchQuery },
        {
          field: "company_name",
          type: "like",
          value: self.searchQuery,
        },
        { field: "investment_type", type: "like", value: self.searchQuery },
        { field: "transaction_type", type: "like", value: self.searchQuery },
      ];
      if (appliedFilters.length == 0) {
        self.tabulator.setFilter([self.searchFilter]);
      } else {
        if (self.searchQuery && self.searchQuery.length > 0) {
          let tabulatorFilter = self.isFilterApplied
            ? [[self.searchFilter], [appliedFilters]]
            : [self.searchFilter];
          self.tabulator.setFilter(tabulatorFilter);
        } else {
          if (self.isFilterApplied) {
            self.tabulator.setFilter([appliedFilters]);
          }
        }
      }
    }, 300),
  },
  computed: {
    moment() {
      return moment;
    },
    formatNumberWithComma() {
      return formatNumberWithComma;
    },
    config() {
      return config;
    },
    ...mapGetters("portfolio", ["portfolioData", "portfolioAll"]),
    ...mapGetters("user", ["user", "currency"]),
    ...mapGetters("investment", ["investments"]),
    ...mapGetters("portfolio", ["portfolioAll"]),
    ...mapGetters("transaction_type", ["transactionTypeData"]),
    ...mapGetters("investment", ["investments"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    transactionDetails: function () {
      let self = this;
      let transactionData = [];

      self.totalIRRCost = 0;
      self.totalIRRProfit = 0;
      self.irrValue = 0;

      let dates = [];
      let values = [];

      let investmentDates = [];

      self.portfolioAll.map((portfolioItem, index) => {
        let investmentData = self.$store.getters[
          "investment/investmentsByPortfolioId"
        ](portfolioItem._id, portfolioItem.workspace);
        let investment = JSON.parse(JSON.stringify(investmentData));

        investment.map((item) => {
          if (!item.created) {
            item.created = item.date || item.transaction_date;
          }

          item.portfolio_item = portfolioItem._id;
          item.investment_type = item.investment_type
            ? item.investment_type
            : "Unknown";
          item.offering = item.offering ? item.offering : "-";
          if (!item.transaction_type) item.transaction_type = "Investment";

          if (item.date) item.date = moment(item.date).format("MM/DD/YYYY");
          else if (item.transaction_date)
            item.date = moment(item.transaction_date).format("MM/DD/YYYY");
          else item.date = "-";
          if (item.transaction_type != "Investment") {
            item.offering = item.offering ? item.offering : "-";
            // item.investment_type = "-";
          }

          if (item.investment_type === "Unknown") {
            item.investment_type = "-";
          }

          if (item.investment_type == "Proceeds") {
            self.totalIRRProfit =
              parseFloat(self.totalIRRProfit) +
              parseFloat(item.amount || item.proceeds_amount || 0);
            values.push(parseFloat(item.amount || item.proceeds_amount || 0));
          } else {
            self.totalIRRCost += parseFloat(item.amount);
            values.push(item.amount * -1);
          }

          dates.push(moment(item.date, "MM/DD/YYYY"));

          if (portfolioItem.status === "Active") {
            // console.log("item.date: ", JSON.parse(JSON.stringify(item)));
            investmentDates.push(moment(item.date, "MM/DD/YYYY"));
          }

          item.attachments = this.$store.getters["file/filesByInvestmentId"](
            item._id
          );
          let data = "";
          item.attachments.map((item) => {
            if (item.link_type == "File")
              data = data.length > 0 ? `${data},${item.name}` : `${item.name}`;
            else data = data.length > 0 ? `${data},${item.url}` : `${item.url}`;
          });
          item.attach = data;
          let json = {};
          json.logo_url =
            portfolioItem.hasOwnProperty("image_id") &&
            portfolioItem.image_id.length > 0
              ? `${config.CRUNCHBASE_IMAGE_URL}/${portfolioItem.image_id}`
              : portfolioItem.logo_url
              ? portfolioItem.logo_url
              : "static/img/generic-logo.png";
          if (portfolioItem.name) json.company_name = portfolioItem.name;
          if (item.notes && item.notes[0] && item.notes[0].description) {
            item.noteId = item.notes[0]._id;
            item.notes = item.notes[0].description;
          } else {
            delete item.notes;
          }
          json = { ...json, ...item };
          json.id = index;
          transactionData.push(json);
        });
      });

      window.moment = moment;

      if (investmentDates.length) {
        let sortedInvestmentDates = investmentDates.sort(function (
          left,
          right
        ) {
          return moment
            .utc(moment.utc(right.format("YYYY-MM-DD")))
            .diff(moment.utc(left.format("YYYY-MM-DD")));
        });

        values.push(parseFloat(self.portfolioValue - self.totalIRRProfit));
        dates.push(sortedInvestmentDates[0]);
      }

      let val = XIRR(values, dates) * 100;

      console.log("values: ", values);
      console.log("dates: ", dates);
      console.log("IRR: ", val);

      if (!isNaN(val)) {
        self.irrValue = parseFloat(val).toFixed(2);
      } else {
        self.irrValue = "-";
      }

      return {
        data: transactionData,
        layout: "fitColumns",
        tooltips: true,
        layoutColumnsOnNewData: true,
        virtualDom: false,
        pagination: "local",
        paginationSize: 20,
        index: "_id",
        paginationSizeSelector: true,
        tooltipsHeader: true,
        initialSort: [{ column: "created", dir: "desc" }],
        placeholder: "No records to view",
        columns: this.tableColumns,
      };
    },
    tableColumns() {
      const self = this;
      let handleMenu = function (_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [
            {
              title: "Edit",
              handler: () => {
                {
                  let data = _cell.getData();
                  if (data.transaction_type == "Investment") {
                    let refer = [];
                    if (data.refer) {
                      data.refer.map((item) => {
                        refer.push({ key: item.attributor, value: item.name });
                      });
                    }

                    self.rowInvestmentData = JSON.parse(JSON.stringify(data));
                    self.investmentData = self.$store.getters[
                      "investment/investmentsByPortfolioId"
                    ](data.portfolio_item, data.workspace);

                    let currentCompany = self.portfolioAll.filter(
                      (item) => item._id == data.portfolio_item
                    );
                    self.currentCompany = currentCompany[0];
                    self.dialogMyInvestmentData = {
                      isShow: true,
                      isCreate: false,
                      data: {
                        _id: data._id,
                        offering: data.offering,
                        transaction_date: data.date || "",
                        amount: data.amount,
                        equity: data.equity,
                        investment_type: data.investment_type
                          ? data.investment_type
                          : "Unknown",
                        equity_standing:
                          data &&
                          data.equity_standing &&
                          data.equity_standing.value
                            ? data.equity_standing.value
                            : "",
                        cohort: data.cohort,
                        term: data.term,
                        cap: data.cap ? data.cap : "",
                        discount: data.discount ? data.discount : "",
                        excerise_price: data.excerise_price
                          ? data.excerise_price
                          : "",
                        price_per_share: data.price_per_share
                          ? data.price_per_share
                          : "",
                        investment_proceeds_type: data.investment_proceeds_type
                          ? data.investment_proceeds_type
                          : "",
                        term_years: data.term_years ? data.term_years : "",
                        no_of_shares: data.no_of_shares
                          ? data.no_of_shares
                          : "",
                        coverage: data.coverage ? data.coverage : "",
                        interest_rate: data.interest_rate
                          ? data.interest_rate
                          : "",
                        interest: data.interest ? data.interest : "",
                        maturity_date: data.maturity_date
                          ? data.maturity_date
                          : "",
                        due_date: data.due_date ? data.due_date : "",
                        security: data.security ? data.security : "",
                        //investment_type: data.direct,
                        referred_by: refer,
                        notes: data.notes,
                        noteId: data.noteId,
                        tags: data.tags ? data.tags : [],
                        is_prorata: data.is_prorata,
                        is_lead_investor: data.is_lead_investor,
                        board_seat: data.board_seat,
                        portfolio_item: data.portfolio_item,
                        workspace: data.workspace,
                        currentValue: self.currentCompany.value,
                        proceeds_amount: data.proceeds_amount,
                      },
                    };
                  } else {
                    self.dialogMyRegistrarData = {
                      isShow: true,
                      isCreate: false,
                      data,
                    };
                  }
                }
              },
            },
            {
              title: "Delete",
              handler: () => {
                self.confirmMdlShow = true;
                self.submitted = false;
                self.deleteItem = _cell.getData();
              },
            },
          ];
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-v" style="color:#0000004D;"></i>
        `;
      };
      return [
        {
          title: "",
          headerSort: false,
          field: "company_name",
          width: 60,
          sorter: false,
          download: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return `
                    <img
            src="${data.logo_url}"
            style="width: 35px;height: 35px;border-radius: 50%;"/>
             <avatar v-else :username="${data.company_name}"></avatar>
          
            `;
          },
          cellClick: function (e, cell) {
            // set the 'current company' and go to the company profile
            let name = cell.getData().company_name;
            // get the ucid
            let ucid = _.reduce(
              self.portfolioAll,
              (memo, data) => {
                if (data.name == name) return data.ucid;
                return memo;
              },
              -1
            );
            // save our current company and go to the profile page
            self.$store.commit("temp/currentCompany", ucid);
            self.$router.push(
              `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${ucid}`
            );
          },
        },
        {
          title: "Company",
          field: "company_name",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            let first = aRow.getData().company_name || "";
            let second = bRow.getData().company_name || "";
            return first.localeCompare(second);
          },
          resizable: true,
          cellClick: function (e, cell) {
            // set the 'current company' and go to the company profile
            let name = cell.getData().company_name;
            // get the ucid
            let ucid = _.reduce(
              self.portfolioAll,
              (memo, data) => {
                if (data.name == name) return data.ucid;
                return memo;
              },
              -1
            );
            // save our current company and go to the profile page
            self.$store.commit("temp/currentCompany", ucid);
            self.$router.push(
              `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${ucid}`
            );
          },
        },
        {
          title: "Date",
          field: "date",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            return new Date(a) - new Date(b); //you must return the difference between the two values
          },
          resizable: true,
        },
        {
          title: "Round",
          field: "offering",
          sorter: "string",
          resizable: true,
          formatter: function (cell, formatterParams) {
            return cell.getData().offering ? cell.getData().offering : "-";
          },
        },
        {
          title: "Expense Type",
          field: "transaction_type",
          width: "172",
          sorter: "string",
          resizable: true,
          formatter: function (cell, formatterParams) {
            let transaction_type = cell.getData().transaction_type;
            let data = self.transactionTypeData.find(
              (item) => item.type == transaction_type
            );
            let color = data ? data.color : "";
            return transaction_type
              ? `
                  <div style="height:25px;background-color:${color}" class="badge invest-badge px-3">${transaction_type}</div>`
              : "-";
          },
        },
        {
          title: "Investment Type",
          field: "investment_type",
          sorter: "string",
          resizable: true,
        },
        {
          title: "Amount",
          field: "amount",
          sorter: "integer",
          resizable: true,
          formatter: function (cell, formatterParams) {
            let values = cell.getData();

            let amount = values.amount;

            let proceeds_amount = values.proceeds_amount;

            if (values.investment_type != "Proceeds") {
              if (amount) {
                return `($${amount})`;
              } else if (proceeds_amount) {
                return `($${proceeds_amount})`;
              } else {
                return `($0)`;
              }
            } else {
              if (amount) {
                return `$${amount}`;
              } else if (proceeds_amount) {
                return `$${proceeds_amount}`;
              } else {
                return `$0`;
              }
            }
          },
        },
        {
          title: "Notes",
          field: "notes",
          resizable: true,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            let notes = cell.getData().notes
              ? cell.getData().notes
              : "";

            if(notes.length > 24){
              notes = notes.slice(0, 22) + "..."
            }
            
            return notes.length > 0
              ? `
                   <div style="cursor:pointer">
            ${notes}`
              : "-";
          },
        },
        {
          title: "Attachments",
          field: "attach",
          download: false,
          formatter: function (cell, formatterParams, onRendered) {
            let data = cell.getData();
            let attach = cell.getData().attach;
            return attach
              ? `<div
            style="cursor:pointer"
            class="circle-icon mt-1"
          >.
            <i class="fa fa-paperclip " style="float: left; padding-top: 0.23rem; padding-left: 0.2rem;"  aria-hidden="true"></i> <div>`
              : "-";
          },
        },
        {
          title: "Created",
          field: "created",
          download: false,
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD HH:mm:ss",
            outputFormat: "MM/DD/YYYY HH:mm:ss",
            invalidPlaceholder: "-",
          },
        },
        {
          // minWidth: "40",
          width: "20",
          resizable: false,
          headerSort: false,
          responsive: 0,
          download: false,
          //formatter: handleMenu,
          formatter: function (_cell, formatterParams) {
            if (self.showDeleteRegistrar && self.showAddButton) {
              if (_cell.getData()) {
                return handleMenu(_cell, formatterParams, formatterParams);
              } else {
                return "";
              }
            } else {
              return "";
            }
          },
        },
      ];
    },
    showAddButton() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "ADD REGISTRAR") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showDeleteRegistrar() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "DELETE REGISTRAR") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    portfolioValue() {
      // sum up our portfolio value
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.value)) sum += item.value;
        });
      }
      return sum;
    },
  },
  created() {},
  data() {
    return {
      vals,
      downloadLink: "",
      confirmMdlShow: false,
      submitted: false,
      perPage: 10,
      attachments: [],
      registrarModal: false,
      rowInvestmentData: {},
      investmentData: [],
      tabulator: null,
      registar: {},
      company_name: "",
      tableLength: 0,
      compayResults: [],
      currentCompany: {},
      files: {
        add: [],
        update: [],
        delete: [],
      },
      title: "",
      isSaving: false,
      dialogMyRegistrarData: {
        isShow: false,
        data: {},
        isCreate: true,
      },
      dialogMyInvestmentData: {
        isShow: false,
        data: {},
        isCreate: true,
      },
      transactionType: [],
      showFilter: false,
      isFilterApplied: false,
      filterDocumentType: "",
      customFilterArray: [],
      companiesList: [],
      searchQuery: "",
      filterRound: "",
      filterInvestmentType: "",
      filterTransactionType: "",
      roundArray: [...vals.INVESTMENT_OFFERINGS, "-"],
      investmentTypeArray: [...vals.INVESTMENT_TYPE, "-"],
      transactionTypeArray: ["Fee", "Cash", "Investment", "Miscellaneous"],

      totalIRRCost: 0,
      totalIRRProfit: 0,
      irrValue: 0,
    };
  },
  mounted() {
    window.moment = moment;
    this.tabulator = new Tabulator(this.$refs.table, this.transactionDetails);
    this.tabulator.hideColumn("created");
    this.tabulator.setSort("created", "desc");
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Registrar`;
  },
  methods: {
    handleParseData(data) {
      let transactionData = [];
      let self = this;

      self.portfolioAll.map((portfolioItem, index) => {
        let investmentData = self.$store.getters[
          "investment/investmentsByPortfolioId"
        ](portfolioItem._id, portfolioItem.workspace);
        let investment = JSON.parse(JSON.stringify(investmentData));
        investment.map((item) => {
          if (!item.created) {
            item.created = item.date || item.transaction_date;
          }

          item.portfolio_item = portfolioItem._id;
          if (!item.transaction_type) item.transaction_type = "Investment";
          if (item.date) item.date = moment(item.date).format("MM/DD/YYYY");
          else if (item.transaction_date)
            item.date = moment(item.transaction_date).format("MM/DD/YYYY");
          else item.date = "-";
          if (item.transaction_type != "Investment" && item.offering)
            item.offering = item.offering;
          item.attachments = this.$store.getters["file/filesByInvestmentId"](
            item._id
          );
          let data = "";
          item.attachments.map((item) => {
            if (item.link_type == "File")
              data = data.length > 0 ? `${data},${item.name}` : `${item.name}`;
            else data = data.length > 0 ? `${data},${item.url}` : `${item.url}`;
          });
          item.attach = data;
          let json = {};
          if (portfolioItem.logo_url) json.logo_url = portfolioItem.logo_url;
          if (portfolioItem.name) json.company_name = portfolioItem.name;
          if (item.notes && item.notes[0] && item.notes[0].description) {
            item.noteId = item.notes[0]._id;
            item.notes = item.notes[0].description;
          } else {
            delete item.notes;
          }
          json = { ...json, ...item };
          json.id = index;
          transactionData.push(json);
        });
      });

      this.tabulator.setSort("created", "desc");

      return transactionData;
    },
    handleCreateRegister() {
      this.dialogMyRegistrarData = {
        isShow: true,
        isCreate: true,
        data: {
          transaction_date: new Date(),
        },
      };
    },
    notesParse(data) {
      return data && data.length > 10 ? `${data.slice(0, 7)}...` : "-";
    },
    async handleDeleteInvestment(data) {
      let param = data;
      this.$store
        .dispatch("investment/deleteInvestment", data)
        .then(async (data) => {
          // this.getInvestmentData();
          // this.$refs.noteRef.getNotes();
          if (
            (param.amount && param.amount.length > 0) ||
            (param.equity_standing && param.equity_standing.value)
          ) {
            let serverData = {};
            if (param.amount && param.amount.length > 0) {
              serverData.cost =
                this.currentCompany.cost > 0
                  ? this.currentCompany.cost - Number(param.amount)
                  : 0;
            }
            serverData._id = this.currentCompany._id;
            serverData.__v = this.currentCompany.__v;
            let investmentOwnershipData = this.investmentData.filter((item) => {
              return item._id != param._id;
            });
            if (param.equity_standing && param.equity_standing.value) {
              let ownership = 0;

              if (investmentOwnershipData.length > 0) {
                for (var i = investmentOwnershipData.length - 1; i >= 0; i--) {
                  if (
                    investmentOwnershipData[i]._id != param._id &&
                    investmentOwnershipData[i].equity_standing &&
                    Number(investmentOwnershipData[i].equity_standing.value) > 0
                  ) {
                    ownership = Number(
                      investmentOwnershipData[i].equity_standing.value
                    );
                    break;
                  }
                }
              }
              serverData.ownership = ownership;
            }
            let path = "company/apiPatchCompanyInst";
            this.$store.dispatch(path, serverData).then((response) => {
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((data) => {});
            });
          }
          let uploadedDocs = await this.$store.getters[
            "file/filesByInvestmentId"
          ](param._id);
          let delCounter = 0;
          if (uploadedDocs.length == 0) {
            this.showSpinner = false;
            this.deleteFlag = false;
            this.getInvestmentData();
            this.$refs.noteRef.getNotes();
            this.attachments;
            this.$toaster.success("Deleted successfully.");
            this.handleCancelDeleteInvestment();
          } else {
            _.forEach(uploadedDocs, async (item) => {
              if (item) {
                let k = await self.$store
                  .dispatch("file/deleteFile", item._id)
                  .then(
                    (item) => {
                      delCounter++;
                      self.$store.dispatch("file/start", null, { root: true });
                    },
                    (error) => {
                      delCounter++;
                      //this.isSaving = false;
                    }
                  );
                if (uploadedDocs.length == delCounter) {
                  this.showSpinner = false;
                  this.deleteFlag = false;
                  this.getInvestmentData();
                  this.$refs.noteRef.getNotes();
                  this.attachments;
                  this.$toaster.success("Deleted successfully.");
                  this.handleCancelDeleteInvestment();
                }
              }
            });
          }
        })
        .catch((err) => {
          this.$toaster.error("Fail to delete.");
          console.log("error in delete investment", err);
          this.handleCancelDeleteInvestment();
        });
    },
    deleteMethod() {
      if (this.deleteItem && this.deleteItem.transaction_type == "Investment") {
        this.submitted = true;
        let param = this.deleteItem;
        const self = this;
        this.$store
          .dispatch("investment/deleteInvestment", this.deleteItem)
          .then(async (data) => {
            let currentCompany = self.portfolioAll.filter(
              (item) => item._id == this.deleteItem.portfolio_item
            );
            self.currentCompany = currentCompany[0];

            self.investmentData = self.$store.getters[
              "investment/investmentsByPortfolioId"
            ](this.deleteItem.portfolio_item, this.deleteItem.workspace);

            if (
              (param.amount && param.amount.length > 0) ||
              (param.equity_standing && param.equity_standing.value)
            ) {
              let serverData = {};
              if (param.amount && param.amount.length > 0) {
                serverData.cost =
                  this.currentCompany.cost > 0
                    ? this.currentCompany.cost - Number(param.amount)
                    : 0;
              }
              serverData._id = this.currentCompany._id;
              serverData.__v = this.currentCompany.__v;
              let investmentOwnershipData = this.investmentData.filter(
                (item) => {
                  return item._id != param._id;
                }
              );
              if (param.equity_standing && param.equity_standing.value) {
                let ownership = 0;

                if (investmentOwnershipData.length > 0) {
                  for (
                    var i = investmentOwnershipData.length - 1;
                    i >= 0;
                    i--
                  ) {
                    if (
                      investmentOwnershipData[i]._id != param._id &&
                      investmentOwnershipData[i].equity_standing &&
                      Number(investmentOwnershipData[i].equity_standing.value) >
                        0
                    ) {
                      ownership = Number(
                        investmentOwnershipData[i].equity_standing.value
                      );
                      break;
                    }
                  }
                }
                serverData.ownership = ownership;
              }
              let path = "company/apiPatchCompanyInst";
              this.$store.dispatch(path, serverData).then((response) => {
                self.$store
                  .dispatch("portfolio/_apiFetchPortfolio")
                  .then((data) => {});
              });
            }
            self.deleteAttachments(param);
          })
          .catch((err) => {
            this.confirmMdlShow = false;
            this.submitted = false;
            this.$toaster.error("Fail to delete.");
          });
      } else {
        this.submitted = true;
        this.$store
          .dispatch("investment/apiRegistrarDelete", this.deleteItem._id)
          .then(async (data) => {
            this.deleteAttachments(this.deleteItem);
          })
          .catch((err) => {
            this.confirmMdlShow = false;
            this.submitted = false;
            this.$toaster.error("Fail to delete.");
          });
      }
    },
    amountParse(data) {
      return (
        "$" + (data.rowData.amount ? formatNumber(data.rowData.amount) : 0)
      );
    },
    async deleteAttachments(param) {
      const self = this;
      let uploadedDocs = await self.$store.getters["file/filesByInvestmentId"](
        param._id
      );
      let delCounter = 0;
      if (uploadedDocs.length == 0) {
        this.confirmMdlShow = false;
        this.submitted = false;
        self.tabulator.deleteRow(param._id);
        this.$toaster.success("Deleted successfully.");
      } else {
        _.forEach(uploadedDocs, async (item) => {
          if (item) {
            let k = await self.$store
              .dispatch("file/deleteFile", item._id)
              .then(
                (item) => {
                  delCounter++;
                  self.$store.dispatch("file/start", null, {
                    root: true,
                  });
                },
                (error) => {
                  delCounter++;
                  //this.isSaving = false;
                }
              );
            if (uploadedDocs.length == delCounter) {
              this.confirmMdlShow = false;
              this.submitted = false;
              self.tabulator.deleteRow(param._id);
              this.$toaster.success("Deleted successfully.");
            }
          }
        });
      }
    },
    attachmentsData(data) {
      this.attachments = [];
      this.attachments = this.$store.getters["file/filesByInvestmentId"](
        data.rowData._id
      );
      this.attachments.map((item) => {
        if (item.s3_path && item.s3_location && item.link_type == "File") {
          if (
            item.s3_path.substring(item.s3_path.length - 4).includes("csv") ||
            item.s3_path.substring(item.s3_path.length - 5).includes("xls")
          )
            item.type = "excel-icon";
          else if (
            item.s3_path.substring(item.s3_path.length - 5).includes("doc")
          )
            item.type = "word-icon";
          else if (
            item.s3_path.substring(item.s3_path.length - 5).includes("pdf")
          )
            item.type = "pdf-icon";
        }
      });
    },
    download() {
      let currentTime = new Date().toLocaleString().split(", ").join("_");
      let fileName = `${this.user.firstName}_${this.user.lastName}_${currentTime}`;
      this.tabulator.download("csv", `${fileName}.csv`);
      this.$toaster.success("Downloaded Successfully");
    },
    clearAll() {
      this.companiesList = [];
      this.filterRound = "";
      this.filterInvestmentType = "";
      this.filterTransactionType = "";
      this.filterJson = {};
      this.isFilterApplied = false;
      this.customFilterArray = [];
      this.tabulator.clearFilter(true);
      this.showFilter = false;
      if (this.searchQuery && this.searchQuery.length > 0) {
        this.tabulator.setFilter([this.searchFilter]);
      }
    },
    applyFilter() {
      let filterJson = [];
      let self = this;
      let filterCompanies = [];
      let companyJson = [];
      self.companiesList.map((item) => {
        companyJson.push({
          field: "company_name",
          type: "=",
          value: item.name,
        });
      });
      if (self.filterRound) {
        filterJson.push({
          field: "offering",
          type: "=",
          value: self.filterRound,
        });
      }
      if (self.filterInvestmentType) {
        filterJson.push({
          field: "investment_type",
          type: "=",
          value: self.filterInvestmentType,
        });
      }
      if (self.filterTransactionType) {
        filterJson.push({
          field: "transaction_type",
          type: "=",
          value: self.filterTransactionType,
        });
      }
      if (companyJson.length) filterJson.push(companyJson);
      self.customFilterArray = filterJson;
      if (this.searchQuery && this.searchQuery.length > 0) {
        let tabulatorFilter = [[self.searchFilter], filterJson];
        self.tabulator.setFilter(tabulatorFilter);
      } else {
        self.tabulator.setFilter(filterJson);
      }
      self.isFilterApplied = true;
      self.showFilter = false;
    },
    searchName({ name, language }) {
      return `${name}`;
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
.fileItem {
  background: #f4f4f4 0% 0% no-repeat padding-box;
  border-radius: 4px;
  height: 32px;
  padding-top: 3px;
  padding-left: 9px;
}
.drag-drop-class {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px dashed #a8a8a8;
  text-align: center;
  border-radius: 0px 4px 4px 0px;
}
.attach-class {
  height: 36px;
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border: 1px solid #c2c2c2;
  text-align: center;
  border-radius: 0px 4px 4px 0px;
  cursor: pointer;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.registrar-table .tabulator-arrow {
  margin-top: 10px !important;
}
.circle-icon {
  cursor: pointer;
  border: 1px solid;
  border-radius: 50%;
  width: 24px;
  text-align: center;
  color: gray;
  padding-top: 1px;
  height: 24px;
}
.invest-badge {
  background: rgba(157, 239, 147, 0.53) 0% 0% no-repeat padding-box;
  border-radius: 13px;
  color: #000000;
  height: 20px;
  font-size: 12px;
  line-height: 20px;
}
.pop-over-custom {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000015;
  border: 1px solid #eaeaea;
  padding-left: 1%;
  padding-bottom: 0.5%;
  padding-right: 0.5%;
}
.vue-avatar--wrapper {
  height: 35px !important;
  width: 35px !important;
}
.downloadCsvTransaction {
  float: right;
}
.flex-name {
  display: flex;
  align-items: center;
}
.img-wrap {
  width: 30px;
  height: 30px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
  border-radius: 5px;
  overflow: hidden;
  display: inline-block;
}
.value-card {
  margin: 15px 0;
}
</style>
